module.exports = __webpack_public_path__ + "media/images/mainfranken-logo-161936cb41f823caea17ec617cd0af76.png";